import { endpoints } from '../../Constants';
// eslint-disable-next-line object-curly-newline
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const comboServices = {
	gateway,
	createCombo,
	viewCombo,
};

function gateway({ req, method }) {
	switch (method) {
		case 'CREATE':
			return createCombo({
				req,
			});
		case 'VIEW':
			return viewCombo({
				req,
			});
		case 'LIST':
			return listCombos({
				req,
			});
		case 'UPDATE':
			return updateCombo({
				req,
			});
		case 'ENABLE':
			return toggleDisableCombo({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function createCombo({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.CREATE_COMBO, requestOptions).then(handleResponse);
}

function updateCombo({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.UPDATE_COMBO, params);

	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function viewCombo({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.VIEW_COMBO, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function listCombos({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.LIST_COMBOS, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function toggleDisableCombo({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.ENABLE_COMBO, params);

	const requestOptions = {
		method: 'PUT',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

export default comboServices;
